module.exports = __webpack_public_path__ + "img/element_6.831eb8ec.png";